import type { InvoiceExampleCatalogEntry } from "./types";

const sampleFilenames = [
  "FSWL Catering Proposal _ HoneyBook.pdf",
  "FSWL Catering Quote _ HoneyBook.pdf",
  "FSWL Full Service Proposal 2026 _ HoneyBook.pdf",
  "FSWL Partial Service + Bar Proposal 2027 _ HoneyBook.pdf",
  "Full Service 2025 _ HoneyBook.pdf",
  "Invoice-9-12.pdf",
] as const;

function invoiceExampleUrl(filename: string): string {
  return `/PDF-Invoice-Examples/${encodeURIComponent(filename)}`;
}

/** Authoritative HoneyBook PDF samples in PDF-Invoice-Examples/ (original filenames preserved). */
export const invoiceExampleCatalog: InvoiceExampleCatalogEntry[] = sampleFilenames.map((filename) => ({
  filename,
  url: invoiceExampleUrl(filename),
}));

export function findInvoiceExample(filename: string): InvoiceExampleCatalogEntry | undefined {
  return invoiceExampleCatalog.find((entry) => entry.filename === filename);
}
